module.exports = __webpack_public_path__ + "static/img/empty.31b548ac.png";